import React, { ReactNode, ReactElement, useState, useEffect } from "react";

type InputProps = {
  placeholder?: string
  value?: string
  options: any
  className?: string
  name?: string
  onChange?: any
  onPressEnter?: any
  status?: 'error' | 'warning' | ''
  validationMessage?: string
};

// Options come from many sources (sockets, REST) with inconsistent field names
// (e.g. { id, name }, { ID, Name }, { value, label }) or even plain strings.
// Resolve the value/label tolerantly so a casing mismatch doesn't render blank rows.
const getOptionValue = (option: any) => {
  if (option == null) return "";
  if (typeof option !== "object") return option;
  return option.id ?? option.ID ?? option.value ?? "";
};

const getOptionLabel = (option: any) => {
  if (option == null) return "";
  if (typeof option !== "object") return String(option);
  return option.name ?? option.Name ?? option.label ?? option.value ?? "";
};

const Select = (props: InputProps) => {
  const [value, setValue] = useState(props.value || "");
  const [options, setOptions] = useState(props.options || []);

  useEffect(() => {
    setOptions(props.options || []);
  }, [props.options]);

  useEffect(() => {
    if (props.value !== undefined) setValue(props.value);
  }, [props.value]);

  const handleOnChange = (e) => {
    setValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  const handleEnterButton = (e) => {
    if (e.key === "Enter") {
      props.onPressEnter(e);
    }
  };


  return (
    <div className={`dataentry-container ${props.status}`}>
      <select
        value={value}
        onChange={(e:  React.ChangeEvent<HTMLSelectElement>) => handleOnChange(e)}
        name={props.name}
        className={props.className}
        onKeyDown={props.onPressEnter && handleEnterButton}
      >
        <option disabled={true} value="" className="placeholder">
          {props.placeholder}
        </option>
        {options &&
          options.map((option: any, y: any) => (
            <option key={y} value={getOptionValue(option)}>
              {getOptionLabel(option)}
            </option>
          ))}
      </select>
      <p className="validation-message">{props.validationMessage}</p>
    </div>
  );
};

export default Select;
